<template>
  <CmsTextRenderer :html="textHtml" />
</template>

<script setup lang="ts">
import { computed } from "vue";
import { CmsRichText } from "../../../services/cms/cms-type-definitions";
import cms from "../../../services/cms/cms";

const props = defineProps<{ text: CmsRichText }>();
const textHtml = computed(() => cms.asHtml(props.text).replace(/\s/g, " "));
</script>
